import React from 'react';
import { TrendingUp, Crosshair, Settings, DollarSign, Fingerprint, UserCheck } from 'lucide-react';

const benefits = [
  {
    icon: TrendingUp,
    title: 'Predictable Pipeline',
    description: 'Know where your next deal comes from. Every single month.',
  },
  {
    icon: Crosshair,
    title: 'Built by Practitioners',
    description: 'Our team has closed millions in B2B deals. Not theorists. Doers.',
  },
  {
    icon: Settings,
    title: 'Systems That Scale',
    description: 'It works whether you have 2 reps or 20.',
  },
  {
    icon: DollarSign,
    title: 'Real Revenue',
    description: 'Money in your bank. Not impressions on a screen.',
  },
  {
    icon: Fingerprint,
    title: 'Tailored to You',
    description: 'No cookie-cutter playbooks. Every system is built for your business.',
  },
  {
    icon: UserCheck,
    title: 'Your Brand, Your Voice',
    description: 'We sound like you. Not like a script.',
  },
];

const Benefits = () => {
  return (
    <section data-testid="benefits-section" className="section" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-lg mb-4">Why Clients Choose Us</h2>
          <p className="text-base md:text-lg" style={{ color: 'var(--text-secondary)' }}>
            We're not for everyone. But if you're serious about growth, here's what you get.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="p-8 rounded-2xl border border-gray-100 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
              data-testid={`benefit-${b.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                style={{ backgroundColor: 'var(--bg-accent)' }}
              >
                <b.icon className="w-6 h-6" style={{ color: 'var(--brand-primary)' }} />
              </div>
              <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
                {b.title}
              </h3>
              <p style={{ color: 'var(--text-secondary)' }}>{b.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
